import React, { useState, useEffect } from "react";

function LoginPage({ onLogin }) {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [shake, setShake] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setTimeout(() => setMounted(true), 50);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!userId.trim() || !password.trim()) {
      setError("Please enter both credentials.");
      triggerShake();
      return;
    }

    setLoading(true);
    // Simulate auth delay
    setTimeout(() => {
      if (userId.trim() === "admin" && password === "123456") {
        onLogin({ name: "Administrator", role: "Admin", id: "admin" });
      } else {
        setLoading(false);
        setError("Invalid credentials. Try admin / 123456");
        triggerShake();
      }
    }, 900);
  };

  const triggerShake = () => {
    setShake(true);
    setTimeout(() => setShake(false), 600);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400&family=DM+Sans:wght@300;400;500;600&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .login-root {
          min-height: 100vh;
          display: flex;
          background: #1a0f0a;
          font-family: 'DM Sans', sans-serif;
          overflow: hidden;
          position: relative;
        }

        /* Animated background particles */
        .login-root::before {
          content: '';
          position: fixed;
          inset: 0;
          background:
            radial-gradient(ellipse 800px 600px at 20% 30%, rgba(184,134,11,0.08) 0%, transparent 70%),
            radial-gradient(ellipse 600px 800px at 80% 70%, rgba(62,39,35,0.6) 0%, transparent 70%),
            radial-gradient(ellipse 400px 400px at 60% 10%, rgba(184,134,11,0.05) 0%, transparent 60%);
          pointer-events: none;
          z-index: 0;
        }

        /* Grid lines */
        .login-root::after {
          content: '';
          position: fixed;
          inset: 0;
          background-image:
            linear-gradient(rgba(184,134,11,0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(184,134,11,0.04) 1px, transparent 1px);
          background-size: 60px 60px;
          pointer-events: none;
          z-index: 0;
        }

        /* LEFT PANEL */
        .login-left {
          flex: 1.1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 60px 80px;
          position: relative;
          z-index: 1;
        }

        .login-left-inner {
          max-width: 480px;
          opacity: 0;
          transform: translateX(-40px);
          transition: all 0.8s cubic-bezier(0.22, 1, 0.36, 1);
        }

        .login-left-inner.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .brand-eyebrow {
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 4px;
          text-transform: uppercase;
          color: #b8860b;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .brand-eyebrow::before {
          content: '';
          width: 32px;
          height: 1px;
          background: #b8860b;
        }

        .brand-headline {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(42px, 5vw, 68px);
          font-weight: 300;
          line-height: 1.1;
          color: #f5f5dc;
          margin-bottom: 8px;
          letter-spacing: -1px;
        }

        .brand-headline em {
          font-style: italic;
          color: #b8860b;
        }

        .brand-sub {
          font-size: 15px;
          color: rgba(245,245,220,0.45);
          line-height: 1.7;
          margin-top: 20px;
          font-weight: 300;
          max-width: 360px;
        }

        /* Decorative interior visual */
        .deco-visual {
          margin-top: 60px;
          position: relative;
        }

        .deco-card {
          background: rgba(245,245,220,0.04);
          border: 1px solid rgba(184,134,11,0.2);
          border-radius: 16px;
          padding: 24px;
          display: flex;
          gap: 20px;
          align-items: center;
          backdrop-filter: blur(10px);
        }

        .deco-icon-wrap {
          width: 52px;
          height: 52px;
          border-radius: 12px;
          background: rgba(184,134,11,0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          flex-shrink: 0;
        }

        .deco-stats {
          display: flex;
          gap: 24px;
          flex-wrap: wrap;
        }

        .deco-stat-item {
          text-align: left;
        }

        .deco-stat-num {
          font-family: 'Cormorant Garamond', serif;
          font-size: 26px;
          font-weight: 600;
          color: #b8860b;
          line-height: 1;
        }

        .deco-stat-label {
          font-size: 11px;
          color: rgba(245,245,220,0.4);
          font-weight: 400;
          letter-spacing: 0.5px;
          margin-top: 2px;
        }

        /* DIVIDER */
        .login-divider {
          width: 1px;
          background: linear-gradient(to bottom, transparent, rgba(184,134,11,0.3) 30%, rgba(184,134,11,0.3) 70%, transparent);
          position: relative;
          z-index: 1;
          flex-shrink: 0;
        }

        /* RIGHT PANEL - FORM */
        .login-right {
          flex: 0.9;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px;
          position: relative;
          z-index: 1;
        }

        .login-card {
          width: 100%;
          max-width: 400px;
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.2s;
        }

        .login-card.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .login-card.shake {
          animation: shake 0.55s cubic-bezier(.36,.07,.19,.97);
        }

        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          15% { transform: translateX(-10px) rotate(-0.5deg); }
          30% { transform: translateX(10px) rotate(0.5deg); }
          45% { transform: translateX(-8px); }
          60% { transform: translateX(8px); }
          75% { transform: translateX(-4px); }
          90% { transform: translateX(4px); }
        }

        .card-header-area {
          text-align: center;
          margin-bottom: 36px;
        }

        .card-logo {
          width: 64px;
          height: 64px;
          background: linear-gradient(135deg, #3e2723, #5d4037);
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          box-shadow: 0 8px 32px rgba(184,134,11,0.2), 0 0 0 1px rgba(184,134,11,0.3);
          font-size: 26px;
          position: relative;
        }

        .card-logo::after {
          content: '';
          position: absolute;
          inset: -1px;
          border-radius: 18px;
          background: linear-gradient(135deg, rgba(184,134,11,0.5), transparent, rgba(184,134,11,0.2));
          z-index: -1;
        }

        .card-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 30px;
          font-weight: 600;
          color: #f5f5dc;
          letter-spacing: -0.5px;
        }

        .card-subtitle {
          font-size: 13px;
          color: rgba(245,245,220,0.4);
          margin-top: 6px;
          font-weight: 300;
        }

        /* Form styling */
        .field-group {
          margin-bottom: 20px;
        }

        .field-label {
          display: block;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: rgba(245,245,220,0.5);
          margin-bottom: 8px;
        }

        .field-wrap {
          position: relative;
        }

        .field-icon {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 15px;
          color: rgba(184,134,11,0.6);
          pointer-events: none;
          z-index: 2;
        }

        .field-input {
          width: 100%;
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(184,134,11,0.2);
          border-radius: 12px;
          padding: 14px 16px 14px 44px;
          color: #f5f5dc;
          font-size: 14px;
          font-family: 'DM Sans', sans-serif;
          font-weight: 400;
          transition: all 0.25s ease;
          outline: none;
          -webkit-appearance: none;
        }

        .field-input::placeholder {
          color: rgba(245,245,220,0.2);
        }

        .field-input:focus {
          background: rgba(184,134,11,0.08);
          border-color: rgba(184,134,11,0.6);
          box-shadow: 0 0 0 3px rgba(184,134,11,0.1), 0 4px 16px rgba(0,0,0,0.2);
        }

        .toggle-pass {
          position: absolute;
          right: 14px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          cursor: pointer;
          color: rgba(245,245,220,0.3);
          font-size: 15px;
          padding: 4px;
          transition: color 0.2s;
          z-index: 2;
        }

        .toggle-pass:hover { color: #b8860b; }

        /* Error */
        .error-msg {
          display: flex;
          align-items: center;
          gap: 8px;
          background: rgba(198,40,40,0.1);
          border: 1px solid rgba(198,40,40,0.3);
          border-radius: 10px;
          padding: 11px 14px;
          color: #ef9a9a;
          font-size: 13px;
          margin-bottom: 20px;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-6px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Submit Button */
        .submit-btn {
          width: 100%;
          padding: 15px;
          background: linear-gradient(135deg, #b8860b, #d4a017);
          border: none;
          border-radius: 12px;
          color: #1a0f0a;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 1px;
          text-transform: uppercase;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          margin-top: 8px;
        }

        .submit-btn::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(255,255,255,0.15), transparent);
          opacity: 0;
          transition: opacity 0.3s;
        }

        .submit-btn:hover::before { opacity: 1; }

        .submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(184,134,11,0.4);
        }

        .submit-btn:active { transform: translateY(0); }

        .submit-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .btn-inner {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        /* Loading spinner */
        .spinner {
          width: 16px;
          height: 16px;
          border: 2px solid rgba(26,15,10,0.3);
          border-top-color: #1a0f0a;
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Hint */
        .login-hint {
          text-align: center;
          margin-top: 24px;
          padding-top: 24px;
          border-top: 1px solid rgba(184,134,11,0.1);
        }

        .hint-text {
          font-size: 12px;
          color: rgba(245,245,220,0.25);
        }

        .hint-text code {
          background: rgba(184,134,11,0.1);
          color: rgba(184,134,11,0.7);
          padding: 2px 7px;
          border-radius: 5px;
          font-size: 11px;
          font-family: 'DM Mono', monospace;
          letter-spacing: 0.5px;
        }

        /* MOBILE RESPONSIVE */
        @media (max-width: 768px) {
          .login-left { display: none; }
          .login-divider { display: none; }
          .login-right {
            flex: 1;
            padding: 24px 20px;
            align-items: flex-start;
            padding-top: 60px;
          }
          .login-card { max-width: 100%; }
        }

        /* Floating orb decorations */
        .orb {
          position: fixed;
          border-radius: 50%;
          filter: blur(80px);
          pointer-events: none;
          z-index: 0;
          animation: drift 8s ease-in-out infinite;
        }

        .orb-1 {
          width: 300px;
          height: 300px;
          background: rgba(184,134,11,0.07);
          top: -100px;
          right: 10%;
          animation-delay: 0s;
        }

        .orb-2 {
          width: 200px;
          height: 200px;
          background: rgba(93,64,55,0.3);
          bottom: 10%;
          left: 5%;
          animation-delay: -4s;
        }

        @keyframes drift {
          0%, 100% { transform: translateY(0px) scale(1); }
          50% { transform: translateY(-30px) scale(1.05); }
        }
      `}</style>

      <div className="login-root">
        {/* Decorative orbs */}
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>

        {/* LEFT BRANDING PANEL */}
        <div className="login-left">
          <div className={`login-left-inner ${mounted ? "visible" : ""}`}>
            <div className="brand-eyebrow">Interior ERP System</div>
            <h1 className="brand-headline">
              Crafting<br />
              <em>Spaces</em>,<br />
              Managing<br />Excellence
            </h1>
            <p className="brand-sub">
              A complete management platform for interior design projects — from client briefs to final handover.
            </p>

            <div className="deco-visual">
              <div className="deco-card">
                <div className="deco-icon-wrap">🏠</div>
                <div className="deco-stats">
                  {[
                    { num: "4+", label: "Active Projects" },
                    { num: "₹28L", label: "Total Budget" },
                    { num: "5", label: "Suppliers" },
                  ].map((s, i) => (
                    <div className="deco-stat-item" key={i}>
                      <div className="deco-stat-num">{s.num}</div>
                      <div className="deco-stat-label">{s.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* VERTICAL DIVIDER */}
        <div className="login-divider"></div>

        {/* RIGHT FORM PANEL */}
        <div className="login-right">
          <div className={`login-card ${mounted ? "visible" : ""} ${shake ? "shake" : ""}`}>

            {/* Card Header */}
            <div className="card-header-area">
              <div className="card-logo">🪑</div>
              <div className="card-title">Welcome Back</div>
              <div className="card-subtitle">Sign in to your workspace</div>
            </div>

            {/* Error */}
            {error && (
              <div className="error-msg">
                <i className="bi bi-exclamation-circle-fill"></i>
                {error}
              </div>
            )}

            {/* Form */}
            <form onSubmit={handleSubmit} autoComplete="off">
              {/* User ID */}
              <div className="field-group">
                <label className="field-label">User ID</label>
                <div className="field-wrap">
                  <span className="field-icon">
                    <i className="bi bi-person-fill"></i>
                  </span>
                  <input
                    type="text"
                    className="field-input"
                    placeholder="Enter your user ID"
                    value={userId}
                    onChange={e => { setUserId(e.target.value); setError(""); }}
                    autoFocus
                    autoComplete="off"
                  />
                </div>
              </div>

              {/* Password */}
              <div className="field-group">
                <label className="field-label">Password</label>
                <div className="field-wrap">
                  <span className="field-icon">
                    <i className="bi bi-lock-fill"></i>
                  </span>
                  <input
                    type={showPass ? "text" : "password"}
                    className="field-input"
                    placeholder="Enter your password"
                    value={password}
                    onChange={e => { setPassword(e.target.value); setError(""); }}
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="toggle-pass"
                    onClick={() => setShowPass(p => !p)}
                    tabIndex={-1}
                  >
                    <i className={`bi ${showPass ? "bi-eye-slash-fill" : "bi-eye-fill"}`}></i>
                  </button>
                </div>
              </div>

              {/* Submit */}
              <button type="submit" className="submit-btn" disabled={loading}>
                <div className="btn-inner">
                  {loading ? (
                    <>
                      <div className="spinner"></div>
                      Authenticating…
                    </>
                  ) : (
                    <>
                      <i className="bi bi-box-arrow-in-right"></i>
                      Sign In
                    </>
                  )}
                </div>
              </button>
            </form>

            {/* Hint */}
            <div className="login-hint">
              <p className="hint-text">
                Demo credentials: <code>admin</code> / <code>123456</code>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginPage;
